import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {Icon} from "../components/Icon";
import {ColorTheme, IconContainerProps} from "../types";

export const ChevronBoldIcon = ({
  colorTheme,
  ...props
}: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const colortheme: ColorTheme = colorTheme || ColorTheme.dark;
  const isLight = colortheme === ColorTheme.light;

  const AthletaSVG = (): JSX.Element => (
    <svg viewBox="0 0 8.207 11.366" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.093 11.366L.021 9.983l5.386-4.18L.001 1.35 1.114-.001l7.094 5.843z" />
      fill={isLight ? theme.color.wh : theme.color.bk}
    </svg>
  );

  const OldNavySVG = (): JSX.Element => (
    <svg viewBox="0 0 7.889 13" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.68 7.005a.714.714 0 000-1.01L1.894.209a.714.714 0 00-1.01 0L.209.884a.714.714 0 000 1.009L4.793 6.5.208 11.107a.714.714 0 000 1.009l.675.675a.714.714 0 001.01 0z" />
      fill={isLight ? theme.color.wh : theme.color.b1}
    </svg>
  );

  const CrossBrandSVG = (): JSX.Element => (
    <svg viewBox="0 0 8.207 11.366" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.093 11.366L.021 9.983l5.386-4.18L.001 1.35 1.114-.001l7.094 5.843z" />
      fill={isLight ? theme.color.wh : theme.color.bk}
    </svg>
  );

  const brandIconSVGs = {
    [Brands.Athleta]: AthletaSVG(),
    [Brands.BananaRepublic]: null,
    [Brands.BananaRepublicFactoryStore]: null,
    [Brands.Gap]: null,
    [Brands.GapFactoryStore]: null,
    [Brands.OldNavy]: OldNavySVG(),
    crossBrand: CrossBrandSVG(),
  };

  return <Icon {...props} brandIconSVGs={brandIconSVGs} />;
};
